"use client";

import { cn } from "@/lib/utils";
import ChatWidget from "@/modules/chat-area/components/chat-widget";
import { useChat } from "@/providers/chat-provider";
import CommunityNavigation from "./community-navigation";
import { usePathname } from "next/navigation";

const CommunityLayoutWrapper = ({ children }: { children: React.ReactNode }) => {
	const { showChatWidget } = useChat();
	const pathname = usePathname();

	if (pathname === "/communities/bim-digital-twin/home") {
		return <>{children}</>;
	}

	if (pathname === "/communities/global-proptech-founders/home") {
		return <>{children}</>;
	}

	if (pathname === "/communities/brokers-agents/home") {
		return <>{children}</>;
	}

	return (
		<div className={cn("flex flex-col md:h-[calc(100vh-3.5rem)]")}>
			<div className="relative flex flex-1 overflow-hidden">
				{/* Left Sidebar */}
				<CommunityNavigation />

				{/* Main Content */}
				<main
					className={cn(
						"customized-scrollbar flex-1 overflow-y-auto overflow-x-hidden rounded-lg bg-gradient-to-b from-brand-primary/5 to-transparent p-4"
					)}
				>
					<div className="mx-auto space-y-4 md:max-w-[800px] xl:max-w-[1200px] 3xl:max-w-[1600px]">
						{children}
					</div>
				</main>

				{showChatWidget ? <ChatWidget /> : null}
			</div>
		</div>
	);
};

export default CommunityLayoutWrapper;
